<template>
  <v-autocomplete v-model="outputData" :items="selectList" :label="lable" item-text="TimeSeriesName" :rules="timeSeriesRule" return-object>
    <template v-slot:item="data">
      <template v-if="typeof data.item !== 'object'">
        <v-list-tile-content v-text="data.item"></v-list-tile-content>
      </template>
      <template v-else>
        <v-list-tile-avatar>
          <v-icon>satellite</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title v-html="data.item.TimeSeriesName"></v-list-tile-title>
        </v-list-tile-content>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
  import {
      createNamespacedHelpers,
    } from 'vuex'
  const continuousimporterconfig = createNamespacedHelpers('continuousimporterconfig')
  export default {
    model: {
      prop: 'inputData',
      event: 'change',
    },
    props: {
      inputData: Object,
      serverType: String,
      lable: {
        type: String,
        default: 'Time Series',
      },
      config: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        outputData: {},
        timeSeriesRule: [
          (v) => {
            if(!Object.values(v).every(x => x.Id && x.TimeSeriesName)) {
              if(this.config[0] && this.config[0].TimeSeries.Id) {
                let IDs = this.config.map(x => x.TimeSeries.Id)
                IDs = IDs.filter(x => x != undefined && x != '')
                IDs = IDs.sort()
                if(IDs.length > 1) {
                  if(this.isRepeat(IDs, v.Id)) {
                    return 'Time Series is selected for the other parameter already.'
                  } else {
                    return false
                  }
                } else {
                  return false
                }
              } else {
                return false
              }
            } else {
              return 'Is required, cannot be null'
            } 
          },
        ],
      }
    },
    mounted() {
      this.outputData = this.inputData
    },
    computed: {
      ...continuousimporterconfig.mapGetters(['TimeSeries', 'NGTimeSeriesList', 'AQUARIUS_SERVER_NG']),
      selectList() {
        if(this.serverType && this.serverType == this.AQUARIUS_SERVER_NG) {
          return this.NGTimeSeriesList
        }
      },
    },
    watch: {
      inputData() {
        this.outputData = this.inputData
      },
      outputData() {
        return this.$emit('change', this.outputData)
      },
    },
    methods: {
      isRepeat(arr, v) {
        let times = 0
        arr.forEach(x => {
          if(x == v){
            ++times
          }
        })
        if(times-1) {
          return true
        } else {
          return false
        }
      },
    },
  }
</script>